/**
 * Retrieves Units
 * @returns {Promise<*[]|*>}
 */
export const getUnits = async () => {
    try {
        const req = await fetch(process.env.NEXT_PUBLIC_API_ENDPOINT + '/api/units', {
            method: 'GET',
            credentials: 'include',
            headers: {
                'Content-Type': "application/json",
                'X-Requested-With': 'XMLHttpRequest',
            }
        });

        let json = await req.json();
        if (json && json.data.length > 0) {
            return json.data;
        }
        return [];
    } catch (e) {
        throw new Error(e);
    }
}

/**
 * Calls API to retrieve the last points from each unit
 * @returns {Promise<*[]|*>}
 */
export const getLastThreePointsFromEachUnit = async () => {
    try {
        const lastActivity = await fetch(process.env.NEXT_PUBLIC_API_ENDPOINT + '/api/statuses/real-time/positions', {
            method: "GET",
            credentials: 'include',
            headers: {
                'Content-Type': "application/json",
                'X-Requested-With': 'XMLHttpRequest',
            }
        });

        let json = await lastActivity.json();
        if (json && json.data.length > 0) {
            return json.data;
        }
        return [];
    }
    catch (e) {
        throw new Error(e);
    }
}